import React from 'react';
import ReactDOM from 'react-dom';
import { Observable } from 'ub_wrapped/rx';

import InlineTextPanel from 'ub/ui/inline-text/inline-text-panel';
import initialState from './initial-state';

import * as TextActions from 'ub/ui/inline-text/text-actions';
import * as subjects from 'ub/ui/inline-text/states/inline-text-state-subjects';

// TODO:
// - We need to make sure any model changes stays within any constraints we have.
//   Example: Min-width of a text element is 20

function changeHandler(ev) {
  subjects.panelEventsSubject.onNext(ev);
}

export default function InlineTextStateController(containerElement) {
  let state = initialState;

  Observable.merge(
    subjects.panelEventsSubject,
    subjects.textEvents // enterEditMode, exitEditMode
  )
    .filter(ev => ev.type)
    .subscribe(ev => {
      state = TextActions[ev.type](state, ev.value) || state;

      ReactDOM.render(
        <InlineTextPanel {...state} changeHandler={changeHandler} />,
        containerElement
      );
    });

  return {
    setElement(element) {
      subjects.panelEventsSubject.onNext({ type: 'setElement', value: element.id });
    },
  };
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/states/inline-text-state-controller.jsx